import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Let’s talk about your project</h2>
            </div>
            <p>
              Let's discuss your project today and bring your vision to life!
              Our expert team is here to listen to your ideas and understand
              your goals accordingly. That’s how we can commit to the delivery
              of a customized solution based on your unique needs. So, contact
              us now to begin your journey towards the digital success of your
              business with our Flutter app development services.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
